import { ReactElement } from 'react';

export enum GlobalBanner {
    Promo = 'promo',
    Payment = 'payment',
    PendingClientPayment = 'pending_client_payment',
    InstantPayoutError = 'instant_payout_error',
    Collaborators = 'collaborators',
    PrismmIntegration = 'prismm_integration',
    PicTimeIntegration = 'pictime_integration',
    showitIntegration = 'showit_integration',
    TimelineGeniusIntegration = 'timeline_genius_integration',
    Weven = 'weven'
}

export interface IGlobalBanner {
    id: GlobalBanner;
    component: (closeBanner) => ReactElement;
    priority: number;
    shouldShowBanner: boolean;
    onClose: () => void;
}

export interface IGlobalBannerProps {
    closeBanner: () => void;
}
